import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {Location} from '@angular/common';


@Component({
  selector: 'card-features',
  templateUrl: './card-features.component.html',
  styleUrls: ['./card-features.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FeaturesComponent implements OnInit {
  public showLoader: boolean = false;
  public cardType = "";


  public switchSingleFeatureItems = [
    {
      'icon': 'Zero_Cross Currency_Fees.png',
      'title': 'Zero Cross Currency Fees',
      'url': '',
    },
    {
        'icon': 'reload_fee.png',
        'title': 'Zero load/reload fee',
        'url': '',
      },
    {
      'icon': 'Zero_annual_maintenance_fee.png',
      'title': 'Zero annual maintenance fee',
      'url': '',
    },
    {
      'icon': 'reload-anywhere.png',
      'title': 'Reload Card Anytime / Anywhere',
      'url': '',
    },
    {
      'icon': 'Tap_&_Pay.png',
      'title': 'Tap & Pay',
      'url': '',
    },
   
    {
      'icon': 'app_enabled_card_mgmt.png',
      'title': 'GlobalPay App Enabled Card Management',
      'url': '',
    },
    {
      'icon': 'Chip_&_Pin-Based_Card.png',
      'title': 'Chip & Pin - Based Card',
      'url': '',
    },
    {
      'icon': 'RealTime_Transaction_Alerts.png',
      'title': 'Real-Time Transaction alerts',
      'url': '',
    },
    {
        'icon': 'Card_Insurance_Coverage_upto_5Lac.png',
        'title': 'Card Insurance Coverage upto 5Lac',
        'url': '',
    },
    {
        'icon': '3D_Secure_Authentication.png',
        'title': '3D Secure Authentication',
        'url': '',
    },
    {
        'icon': 'Not_Linked_to_Your_Bank.png',
        'title': 'Not Linked to Your Bank Account',
        'url': '',
    },
    {
        'icon': 'Surcharge_Free_withdrawals_at_ATMs.png',
        'title': 'Surcharge Free withdrawals at AllPoint ATMs',
        'url': '',
    },
  ];
 
  public switchMultiFeatureItems = [
    {
      'icon': '30_multi_currencies_wallets.png',
      'title': '30 multi-currencies wallets',
      'url': '',
    },
    {
        'icon': 'reload_fee.png',
        'title': 'Zero load/reload fee',
        'url': '',
      },
    {
      'icon': 'Zero_annual_maintenance_fee.png',
      'title': 'Zero annual maintenance fee',
      'url': '',
    },
    {
      'icon': 'reload-anywhere.png',
      'title': 'Reload Any time Anywhere',
      'url': '',
    },
    {
      'icon': 'Tap_&_Pay.png',
      'title': 'Tap & Pay',
      'url': '',
    },
    {
      'icon': 'app_enabled_card_mgmt.png',
      'title': 'GlobalPay App enabled card management',
      'url': '',
    },
    {
      'icon': '24-7_Customer_service.png',
      'title': '24/7 Customer service',
      'url': '',
    },
    {
      'icon': 'RealTime_Transaction_Alerts.png',
      'title': 'Real Time Transaction Alert',
      'url': '',
    },
    {
        'icon': 'Card_Insurance_Coverage_upto_5Lac.png',
        'title': 'Card Insurance Coverage up to ₹5 Lakhs',
        'url': '',
    },
    {
        'icon': '3D_Secure_Authentication.png',
        'title': '3D Secure E-Commerce Authentication',
        'url': '',
    },
    {
        'icon': 'Customizable_Spending_Limits.png',
        'title': 'Customizable Spending Limits',
        'url': '',
    },
  ];

  public uniZCardFeatureItems = [
    {
      'icon': '12-Currency-Wallet.png',
      'title': '30 International Currencies',
      'url': '',
    },
    {
        'icon': 'reload-anywhere.png',
        'title': 'Reload anytime',
        'url': '',
      },
    {
      'icon': 'app_enabled_card_mgmt.png',
      'title': 'App-enabled card management',
      'url': '',
    },
    {
      'icon': 'Not_Linked_to_Your_Bank.png',
      'title': 'Not linked to your bank account',
      'url': '',
    },
    {
      'icon': 'reload-anywhere.png',
      'title': 'Accepted at VISA online merchants worldwide',
      'url': '',
    },
    {
      'icon': '24-7_Customer_service.png',
      'title': '24/7 Customer service',
      'url': '',
    },
    {
      'icon': 'Tap_&_Pay.png',
      'title': 'Instant transaction alerts via SMS and email',
      'url': '',
    },
    {
        'icon': '3D_Secure_Authentication.png',
        'title': '3D Secure authentication for online payments',
        'url': '',
    },
    {
        'icon': 'Card_Insurance_Coverage_upto_5Lac.png',
        'title': 'Card Insurance Coverage up to ₹5 Lakhs',
        'url': '',
    },
  ];



  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public toast: ToastrService,
    private _location: Location
   
  ) { 
    this.cardType = this.route.snapshot.paramMap.get('cardType');

  }

  ngOnInit() {

  }


  goToBackPage() {
    this._location.back();
  }

  
}
